//This function produces random IDs for HTML elements
//and does not have security importance.
export default function genID() {
  return `id-${Math.floor(Math.random() * 99999)}`;
}
